import { EmptyState, FiFileText, ReadOnlyField } from '@agrotoken-tech/ui';
import {
  CompanyContactInformationSerializer,
  ExplorerAccessibleSectionSerializer,
} from '@bcba/serializers';
import { RestrictedSection } from './RestrictedSection';
import { SectionGrid } from '../../SectionGrid';
import { useTranslation } from '@bcba/react-hooks';

interface Props {
  contactInformation: ExplorerAccessibleSectionSerializer<CompanyContactInformationSerializer>;
}

export const ReadOnlyContactInfoSection = ({ contactInformation }: Props) => {
  const { t } = useTranslation();
  const { hasAccess, data } = contactInformation;

  if (!hasAccess) return <RestrictedSection />;

  if (!data)
    return (
      <EmptyState
        title={t('sharedDigitalDossier.contactInformation.emptyState.title')}
        description={t(
          'sharedDigitalDossier.contactInformation.emptyState.description',
        )}
        size="md"
        icon={FiFileText}
      />
    );

  return (
    <SectionGrid maxWidth={'868px'}>
      <ReadOnlyField label={t('common.street')} value={data.street} />
      <ReadOnlyField label={t('common.number')} value={data.streetNumber} />
      <ReadOnlyField label={t('common.province')} value={data.provinceName} />
      <ReadOnlyField label={t('common.locality')} value={data.localityName} />
      <ReadOnlyField label={t('common.postalCode')} value={data.postalCode} />
      <ReadOnlyField label={t('common.phone')} value={data.phoneNumber} />
      <ReadOnlyField label={t('common.email')} value={data.email} />
      <ReadOnlyField label={t('common.web')} value={data.website ?? '-'} />
    </SectionGrid>
  );
};
